<template>
 <div>
    mh-component-1
 </div>
</template>

<script>
export default {
    name: 'mh-component-1'
}
</script>

<style>

</style>